export default "__VITE_ASSET__CzSisKOT__"